import { render, staticRenderFns } from "./MassActionDropdown.vue?vue&type=template&id=60ddad11&scoped=true"
import script from "./MassActionDropdown.vue?vue&type=script&lang=js"
export * from "./MassActionDropdown.vue?vue&type=script&lang=js"
import style0 from "./MassActionDropdown.vue?vue&type=style&index=0&id=60ddad11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ddad11",
  null
  
)

export default component.exports